// Modified helpers for V2
import {
  setLotSizeValue,
  wantAdBudgetValue,
  wantAdSqftValue,
} from "../createWantAd";

export const getDescriptionText = (adDetails) => {
  const prprtyType = _.get(adDetails, "prprtyType", []);
  const lotType = _.get(adDetails, "lotType", null);
  const adType = _.get(adDetails, "adType", null);
  let ltSize = "";
  ltSize = setLotSizeValue(
    _.get(adDetails, "minLtSz", null),
    _.get(adDetails, "maxLtSz", null)
  );
  let sqFt = wantAdSqftValue(
    _.get(adDetails, "sqFtMin", ""),
    _.get(adDetails, "sqFtMax", "")
  );

  let bdgt = wantAdBudgetValue(
    _.get(adDetails, "minBdgt", ""),
    _.get(adDetails, "maxBdgt", "")
  );
  let noBathRoom = _.get(adDetails, "noBathRm", "") || "Any";
  let noBedRoom = _.get(adDetails, "noBedRm", "") || "Any";
  let noBeds = _.get(adDetails, "noOfBeds", "") || "Any";
  if (noBathRoom && noBathRoom !== "Any") noBathRoom = noBathRoom + "+";
  if (noBedRoom && noBedRoom !== "Any") noBedRoom = noBedRoom + "+";
  if (noBeds && noBeds !== "Any") noBeds = noBeds + "+";
  const lotTypeText = lotType
    ? lotType === "1"
      ? "Rural"
      : "In city limits"
    : "";

  // Decided to keep budget as must haves for prprtyType 11 rather than ""
  if (adType === "STR") {
    if (prprtyType == 6) {
      return "LOT SIZE " + ltSize + " | " + "BUDGET " + bdgt;
    } else if (prprtyType == 11) {
      return "BUDGET " + bdgt;
    } else {
      return (
        " BEDS " +
        noBedRoom +
        " | " +
        " BATHS " +
        noBathRoom +
        " | " +
        " SQFT " +
        sqFt +
        " | " +
        "BUDGET " +
        bdgt
      );
    }
  } else {
    if (prprtyType == 6) {
      return "LOT SIZE " + ltSize + " | " + "BUDGET " + bdgt;
    } else if (prprtyType == 11) {
      return "BUDGET " + bdgt;
    } else {
      return (
        " BEDS " +
        noBedRoom +
        " | " +
        " BATHS " +
        noBathRoom +
        " | " +
        " SQFT " +
        sqFt +
        " | " +
        "BUDGET " +
        bdgt
      );
    }
  }
};
